import React from 'react';
import Header from '@/features/customer/auth/components/Header';
import Main from '../components/Main';
import Footer from '@/features/customer/top/components/Footer';

const ForgotPassowrd = () => {
  return (
    <React.Fragment>
      <Header />
      <Main />
      <Footer />
    </React.Fragment>
  );
};

export default ForgotPassowrd;